export const sortRecordByValue = <T extends string | number>(
  record: Record<T, string>,
  language?: string
) => {
  return Object.entries(record).sort(([, a]: any, [, b]: any) => {
    return a.localeCompare(b, language);
  }) as [T, string][];
};
